
import { GTM_FREEBLE } from "./const"
import { showGlobalMessage, openNoAddressPop } from "@/utils/utils"
import { handleModifyCartV2 } from "@/utils/cartResponse"
import { trackRedemptionOrGift } from "@/utils/track"
export default {
  API: ["reduce"],
  name: "CountControl",
  inject: {
    getStoreId: {
      default: null
    },
    source: {
      default: null
    }
  },
  props: {
    autoAddCart: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Number, String],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 99
    },
    info: {
      type: Object,
      default: () => {}
    },
    sku: {
      type: [Number, String],
      default: ""
    },
    proId: {
      type: [Number, String],
      default: ""
    },
    idKey: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      curValue: this.value,
      storeId: "",
      showCountControl: false
    }
  },
  computed: {
    increaseDisabled() {
      return Number(this.curValue) >= this.max
    },
    reduceDisabled() {
      return Number(this.curValue) <= this.min
    }
  },
  watch: {
    value() {
      this.curValue = this.value
    }
  },
  // eslint-disable-next-line require-await
  async created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
    this.storeId = this.getStoreId ? this.getStoreId() : commonReqParams.storeId
  },
  methods: {
    autoHideInput() {
      this.clearTimer()
      this.timer = setTimeout(() => {
        this.showCountControl = false
      }, 3000)
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    async reduce() {
      if (this.reduceDisabled) return
      if (!this.autoAddCart) {
        this.$emit("reduce", this.info)
        return
      }
      const num = Number(this.curValue) - 1
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data] = await handleModifyCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.sku, beforeCount: this.curValue, count: num, checked: 1 }],
        sort: 1,
        otherParams: {
          [this.idKey]: this.proId
        }
      })
      if (error) {
        this.afterAddCardError(error)
      }
      if (data) {
        this.afterAddCard(data, num)
        trackRedemptionOrGift([{ ...this.info, beforeCount: this.curValue + 1, count: num }], [], GTM_FREEBLE)
      }
      loading.close()
    },
    async increase() {
      if (this.increaseDisabled) return
      if (!this.autoAddCart) {
        this.$emit("increase", this.info)
        return
      }
      const num = Number(this.curValue) + 1
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data] = await handleModifyCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.sku, beforeCount: this.curValue, count: num, checked: 1 }],
        sort: 1,
        otherParams: {
          giftProId: this.proId
        }
      })
      if (error) {
        this.afterAddCardError(error)
      }
      if (data) {
        this.afterAddCard(data, num)
        trackRedemptionOrGift([{ ...this.info, beforeCount: this.curValue - 1, count: num }], [], GTM_FREEBLE)
      }
      loading.close()
    },
    handleEmit(value) {
      if (value === "") {
        this.curValue = value = this.min
      }
      this.$bus.$emit("add-cart-success", this.source)
      if (this.source === "collect") {
        this.$bus.$emit("reload-collect")
      }
    },
    afterAddCardError(error) {
      this.curValue = this.value
      if (error && error.code == "44999") {
        openNoAddressPop()
      } else {
        // this.$message.error(error.result)
      }
    },
    afterAddCard(res, num) {
      this.curValue = num
      this.autoHideInput()
      this.handleEmit(this.curValue)
      // if (res.adequateStock) {
      //   this.curValue = num;
      //   this.handleEmit(this.curValue);
      // } else {
      //   this.curValue = this.value;
      // }
    }
  }
}
